export default "__VITE_ASSET__CGT_pGGQ__"